import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Home from './pages';
import NotFound from './components/NotFound';
import Participants from './components/Participants';
import Agenda from './components/Program';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/rubinwebpage/" element={<Home />} />
          <Route path="/rubinwebpage/participants" element={<Participants />} />
          <Route path="/rubinwebpage/program" element={<Agenda />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
